import { useQuery } from '@tanstack/react-query';
import { httpClient } from '@s20/services/httpClient';
import { ApiRoutes } from '../../../Common';
import ValidatedSelect from '../../../common/forms/ValidatedSelect';

export const JobType = () => {
    const { data, isLoading } = useQuery({
        queryKey: ['jobTypes'],
        queryFn: () => httpClient.js(ApiRoutes.typeAheads.jobTypes()),
    });

    return (
        <ValidatedSelect
            id="jobTypeId"
            name="jobTypeId"
            label="What type of work is being done?"
            options={data}
            isLoading={isLoading}
            required={(data ?? []).some((x) => x.timesheetRequiresWorkflowNotes)}
            error="A job type must be selected"
        />
    );
};